//NEW: UI_REVAMP
import { Text, VStack } from '@chakra-ui/react';
import { useMemo } from 'react';
import { useBettingList } from '../../hooks/useBettingList';
import { getMinBetAmount } from '../../utils/getMinBetAmount';
import BetListAccordion from './BetListAccordion';

const BettingList = ({ getGame, invalidBetIds = [], setInvalidBetIds, pb }) => {
	const { allBetting, removeBetting, categories, updateBetPrice } = useBettingList(getGame);
	const minBetAmounts = useMemo(() => {
		const mapping = {};
		getGame.data?.forEach((game) => {
			mapping[game.name] = game.minBetAmount;
		});
		return mapping;
	}, [getGame.data]);

	const columns = useMemo(
		() => [
			{ key: 'digit', label: 'Numbers', flex: { base: 1, xl: 1.4 } },
			{ key: 'odds', label: 'Odds', flex: { base: 1, xl: 1.4 } },
			{ key: 'betPrice', label: 'Bet Price (PHP)', flex: 1 },
		],
		[],
	);

	const handlePriceChange = (id, value) => {
		const numericValue = value.replace(/[^0-9]/g, '').slice(0, 16);
		const newPrice = numericValue === '' ? '' : Number(numericValue);
		updateBetPrice(id, newPrice);

		const bet = allBetting.find((b) => b.id === id);
		const minAmt = getMinBetAmount(getGame, bet?.gameId);

		if (newPrice >= minAmt && invalidBetIds.includes(id)) {
			setInvalidBetIds((prev) => prev.filter((prevId) => prevId !== id));
		}
	};

	return (
		<VStack h='full' p={2} overflowY='auto' align='stretch' w='full' spacing={2} pb={pb}>
			{allBetting.length === 0 ? (
				<Text fontSize='14px' fontWeight={600} color='#2D0707' textAlign='center'>
					No bets
				</Text>
			) : (
				categories.map((cat) => {
					const bets = allBetting.filter(
						(b) => b.gameType === cat.gameType && b.betType === cat.betType,
					);

					return (
						<BetListAccordion
							key={`${cat.gameType}-${cat.betType}`}
							columns={columns}
							gameType={cat.gameType}
							betType={cat.betType}
							data={bets}
							onPriceChange={handlePriceChange}
							removeBetting={removeBetting}
							invalidBetIds={invalidBetIds}
							minBetAmounts={minBetAmounts}
						/>
					);
				})
			)}
		</VStack>
	);
};

export default BettingList;
